export var normalizeTeams = function normalizeTeams() {
  //TODO Remove this mock data and replace with actual data from the API
  var colors = {
    jsonObj: {
      teams: {
        108: {
          name: "Angels",
          city: "Los Angeles",
          bgroundColor: "#003263",
          spotColor: "#862633",
          venue: "1"
        },
        109: {
          name: "D-backs",
          city: "Arizona",
          bgroundColor: "#A51E31",
          spotColor: "#E3D4AD",
          venue: "15"
        },
        110: {
          name: "Orioles",
          city: "Baltimore",
          bgroundColor: "#000000",
          spotColor: "#DF4601",
          venue: "2"
        },
        111: {
          name: "Red Sox",
          city: "Boston",
          bgroundColor: "#BD3039",
          spotColor: "#0D2B56",
          venue: "3"
        },
        112: {
          name: "Cubs",
          city: "Chicago",
          bgroundColor: "#0E3386",
          spotColor: "#CB3433",
          venue: "17"
        },
        113: {
          name: "Reds",
          city: "Cincinnati",
          bgroundColor: "#C52127",
          spotColor: "#333333",
          venue: "2602"
        },
        114: {
          name: "Guardians",
          city: "Cleveland",
          bgroundColor: "#002B5C",
          spotColor: "#E11D38",
          venue: "5"
        },
        115: {
          name: "Rockies",
          city: "Colorado",
          bgroundColor: "#33006F",
          spotColor: "#C4CED4",
          venue: "19"
        },
        116: {
          name: "Tigers",
          city: "Detroit",
          bgroundColor: "#0C2C56",
          spotColor: "#FF6700",
          venue: "2394"
        },
        117: {
          name: "Astros",
          city: "Houston",
          bgroundColor: "#002D62",
          spotColor: "#EB6E1F",
          venue: "2392"
        },
        118: {
          name: "Royals",
          city: "Kansas City",
          bgroundColor: "#004687",
          spotColor: "#7AB2DD",
          venue: "7"
        },
        119: {
          name: "Dodgers",
          city: "Los Angeles",
          bgroundColor: "#005A9C",
          spotColor: "#FFFFFF",
          venue: "22"
        },
        120: {
          name: "Nationals",
          city: "Washington",
          bgroundColor: "#041e42",
          spotColor: "#AB0003",
          venue: "3309"
        },
        121: {
          name: "Mets",
          city: "New York",
          bgroundColor: "#002D72",
          spotColor: "#FF5910",
          venue: "3289"
        },
        133: {
          name: "Athletics",
          city: "",
          bgroundColor: "#006241",
          spotColor: "#ffc547",
          venue: "10"
        },
        134: {
          name: "Pirates",
          city: "Pittsburgh",
          bgroundColor: "#333333",
          spotColor: "#FCB723",
          venue: "31"
        },
        135: {
          name: "Padres",
          city: "San Diego",
          bgroundColor: "#2F241D",
          spotColor: "#FFC425",
          venue: "2680"
        },
        136: {
          name: "Mariners",
          city: "Seattle",
          bgroundColor: "#0c2c56",
          spotColor: "#005C5C",
          venue: "680"
        },
        137: {
          name: "Giants",
          city: "San Francisco",
          bgroundColor: "#333333",
          spotColor: "#FD5A1E",
          venue: "2395"
        },
        138: {
          name: "Cardinals",
          city: "St. Louis",
          bgroundColor: "#001541",
          spotColor: "#C41E3A",
          venue: "2889"
        },
        139: {
          name: "Rays",
          city: "Tampa Bay",
          bgroundColor: "#1B2E5B",
          spotColor: "#8FBCE6",
          venue: "12"
        },
        140: {
          name: "Rangers",
          city: "Texas",
          bgroundColor: "#003278",
          spotColor: "#C0101E",
          venue: "5325"
        },
        141: {
          name: "Blue Jays",
          city: "Toronto",
          bgroundColor: "#134A8E",
          spotColor: "#D50032",
          venue: "14"
        },
        142: {
          name: "Twins",
          city: "Minnesota",
          bgroundColor: "#1B75BB",
          spotColor: "#D31E47",
          venue: "3312"
        },
        143: {
          name: "Phillies",
          city: "Philadelphia",
          bgroundColor: "#003087",
          spotColor: "#E81828",
          venue: "2681"
        },
        144: {
          name: "Braves",
          city: "Atlanta",
          bgroundColor: "#0c2340",
          spotColor: "#BA0D2F",
          venue: "4705"
        },
        145: {
          name: "White Sox",
          city: "Chicago",
          bgroundColor: "#333333",
          spotColor: "#D8D8D8",
          venue: "4"
        },
        146: {
          name: "Marlins",
          city: "Miami",
          bgroundColor: "#000000",
          spotColor: "#00A3E0",
          venue: "4169"
        },
        147: {
          name: "Yankees",
          city: "New York",
          bgroundColor: "#003087",
          spotColor: "#B0B0B0",
          venue: "3313"
        },
        158: {
          name: "Brewers",
          city: "Millwaukee",
          bgroundColor: "#12284B",
          spotColor: "#FFC72C",
          venue: "32"
        }
      }
    }
  };
  return [{
    abbreviation: "ATH",
    clubName: "Athletics",
    franchiseName: "Athletics",
    id: 133
  }, {
    abbreviation: "PIT",
    clubName: "Pirates",
    franchiseName: "Pittsburgh",
    id: 134
  }, {
    abbreviation: "SD",
    clubName: "Padres",
    franchiseName: "San Diego",
    id: 135
  }, {
    abbreviation: "SEA",
    clubName: "Mariners",
    franchiseName: "Seattle",
    id: 136
  }, {
    abbreviation: "SF",
    clubName: "Giants",
    franchiseName: "San Francisco",
    id: 137
  }, {
    abbreviation: "STL",
    clubName: "Cardinals",
    franchiseName: "St. Louis",
    id: 138
  }, {
    abbreviation: "TB",
    clubName: "Rays",
    franchiseName: "Tampa Bay",
    id: 139
  }, {
    abbreviation: "TEX",
    clubName: "Rangers",
    franchiseName: "Texas",
    id: 140
  }, {
    abbreviation: "TOR",
    clubName: "Blue Jays",
    franchiseName: "Toronto",
    id: 141
  }, {
    abbreviation: "MIN",
    clubName: "Twins",
    franchiseName: "Minnesota",
    id: 142
  }, {
    abbreviation: "PHI",
    clubName: "Phillies",
    franchiseName: "Philadelphia",
    id: 143
  }, {
    abbreviation: "ATL",
    clubName: "Braves",
    franchiseName: "Atlanta",
    id: 144
  }, {
    abbreviation: "CWS",
    clubName: "White Sox",
    franchiseName: "Chicago",
    id: 145
  }, {
    abbreviation: "MIA",
    clubName: "Marlins",
    franchiseName: "Miami",
    id: 146
  }, {
    abbreviation: "NYY",
    clubName: "Yankees",
    franchiseName: "New York",
    id: 147
  }, {
    abbreviation: "MIL",
    clubName: "Brewers",
    franchiseName: "Milwaukee",
    id: 158
  }, {
    abbreviation: "LAA",
    clubName: "Angels",
    franchiseName: "Los Angeles",
    id: 108
  }, {
    abbreviation: "AZ",
    clubName: "Diamondbacks",
    franchiseName: "Arizona",
    id: 109
  }, {
    abbreviation: "BAL",
    clubName: "Orioles",
    franchiseName: "Baltimore",
    id: 110
  }, {
    abbreviation: "BOS",
    clubName: "Red Sox",
    franchiseName: "Boston",
    id: 111
  }, {
    abbreviation: "CHC",
    clubName: "Cubs",
    franchiseName: "Chicago",
    id: 112
  }, {
    abbreviation: "CIN",
    clubName: "Reds",
    franchiseName: "Cincinnati",
    id: 113
  }, {
    abbreviation: "CLE",
    clubName: "Guardians",
    franchiseName: "Cleveland",
    id: 114
  }, {
    abbreviation: "COL",
    clubName: "Rockies",
    franchiseName: "Colorado",
    id: 115
  }, {
    abbreviation: "DET",
    clubName: "Tigers",
    franchiseName: "Detroit",
    id: 116
  }, {
    abbreviation: "HOU",
    clubName: "Astros",
    franchiseName: "Houston",
    id: 117
  }, {
    abbreviation: "KC",
    clubName: "Royals",
    franchiseName: "Kansas City",
    id: 118
  }, {
    abbreviation: "LAD",
    clubName: "Dodgers",
    franchiseName: "Los Angeles",
    id: 119
  }, {
    abbreviation: "WSH",
    clubName: "Nationals",
    franchiseName: "Washington",
    id: 120
  }, {
    abbreviation: "NYM",
    clubName: "Mets",
    franchiseName: "New York",
    id: 121
  }].map(function (_ref) {
    var _colors$jsonObj, _colors$jsonObj$teams, _colors$jsonObj$teams2;
    var abbreviation = _ref.abbreviation,
      clubName = _ref.clubName,
      franchiseName = _ref.franchiseName,
      id = _ref.id;
    return {
      abbreviation: abbreviation,
      activeBorderColor: colors === null || colors === void 0 ? void 0 : (_colors$jsonObj = colors.jsonObj) === null || _colors$jsonObj === void 0 ? void 0 : (_colors$jsonObj$teams = _colors$jsonObj.teams) === null || _colors$jsonObj$teams === void 0 ? void 0 : (_colors$jsonObj$teams2 = _colors$jsonObj$teams[id]) === null || _colors$jsonObj$teams2 === void 0 ? void 0 : _colors$jsonObj$teams2.spotColor,
      alt: "".concat(franchiseName, " ").concat(clubName, " logo"),
      id: id,
      name: clubName,
      superName: franchiseName,
      type: "team"
    };
  }).sort(function (a, b) {
    return a.superName.localeCompare(b.superName);
  });
};